export enum SelectedComicOptionEnum {
  GENRE = 'GENRE',
  COMIC_NAME = 'COMIC_NAME'
}
